import { FeatureCatalog } from '@aibees/shared/definition';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import { useCustomerEndpoint, useWorkspace } from '@aibees/shared/workspace';

export function useBrowseProductEntitlementApi() {
  const url = useCustomerEndpoint('entitlement');
  const wid = useWorkspace()?.id;

  // `url` embeds the workspace id, so it has to be part of the key — otherwise
  // a workspace switch without a full remount serves the previous customer's
  // entitlements from cache.
  return useBaseQuery<never, FeatureCatalog>(
    [useBrowseProductEntitlementApi.name, url],
    {
      url,
      params: {
        return: 'features',
        groupByFamily: true,
      },
    },
    { enabled: !!wid }
  );
}
